import { Curated, Television, WebPage } from '@js/web/components/icons';

export const premierAboutContent = {
  title: ['How it Works.', 'Premier Auction.'],
  body: [
    'Our Premier Auction venue, which we designed from scratch, provides the market\'s highest investment caliber assets with the finest possible auction staging.',
    'Trading cards are quickly becoming the world’s preferred tangible asset. The Premier Auction empowers investors to engage in this quickly expanding sector. Every item valued at or above $20,000 receives industry-leading photography, an original written description, video commentary, and marketing outreach. Items valued below this threshold are NOT guaranteed video or written descriptions.'
  ],
  textSide: 'left',
  backgroundColor: 'white',
  imageUrlDesktop: jsConfig.links.imagesUrl + 'about-premier-experience-desktop.png',
  imageUrlMobile: jsConfig.links.imagesUrl + 'about-premier-experience-mobile.png',
  titleType: 'h1',
  overflowImage: false,
  noAssetBackground: true,
  containImage: true
};

export const premierTripleIconMessages = [
  {
    icon: Television,
    iconColor: '#FFF',
    iconBgColor: '#282828',
    title: ['Newest Technology'],
    message: 'Industry first 360-degree imaging, professional photography, and the finest auction software.'
  },
  {
    icon: WebPage,
    iconColor: '#FFF',
    iconBgColor: '#282828',
    title: ['Best Content & Marketing'],
    message: 'Extensive asset descriptions, detailed video assessments, and aggressive marketing outreach'
  },
  {
    icon: Curated,
    iconColor: '#FFF',
    iconBgColor: '#282828',
    title: ['Record Prices + Highest Seller Net'],
    message: 'Our sellers reap a higher commission and net more than any other venue.'
  },
];

export const premierFees = {
  title: 'Commission Example',
  hasBorderTop: true,
  smallTitle: true,
  priceSections: [
    {
      price: '<div class="d-flex flex-column justify-content-center align-items-center" style="min-height:54px"><span><b>$250,000</b></span></div>',
      label: 'Hammer / final bid amount',
    },
    {
      price: '<div class="d-flex flex-column justify-content-center align-items-center" style="min-height:54px"><span><b>$250,00 + 12.5%</b></span></div>',
      label: 'Seller receives a bonus commission + hammer amount',
    },
    {
      price: '<div class="d-flex flex-column justify-content-center align-items-center" style="min-height:54px"><span><b>$281,250</b></span></div>',
      label: 'Total seller commission received',
    },
  ],
  showSubmitButton: false
};

export const premierDescription = {
  body: [
    '<p>Designed to accommodate buyers searching for high-potential investments, this venue provides collectors an opportunity to build and diversify their portfolio.</p>',
    '<p>Registered users must receive approval from Fanatics Collect staff to participate in a Premier Auction. Please hit the button below to request approval.</p>',
    '<p>Extended bidding starts at 7:00 p.m. PT on the stated closing night. All Premier lots remain open and active until the auction clock expires. The clock window resets with each bid received, and the auction ends entirely if the current window does not receive any bids.</p>',
    '<p>The extended bidding window gets smaller as extended bidding progresses, starting with five-minute windows at 7:00 p.m. PT, reduced to two-minute windows at 7:30 p.m. PT, and then reduced further to one minute at 8:00 p.m. PT. Half-bidding-increments are enabled during the one-minute window period.</p>',
    '<p>Track your bids seamlessly from the Fanatics Collect members portal and trade like a pro! <b>Buyers are afforded free lifetime Fanatics Vault services on every purchase. Avoid costly shipping fees and sales taxes too! All items, regardless of category or value, receive free Vault, free shipping, and zero sales tax.</b></p>',
    '<p class="mb-0">A 20% buyer\'s premium is added to the hammer price on every auction item.</p>',
  ],
  title: 'Bidding In The Premier Auction',
  desktopImage: jsConfig.links.imagesUrl + 'extended-auction-calendar-desktop-2.png',
  mobileImage: jsConfig.links.imagesUrl + 'extended-auction-calendar-mobile-2.png',
  darkButtonLink: jsConfig.links?.monthlyUrl,
  darkButtonText: 'View Auction',
  defaultButtonLink: jsConfig.links?.monthlyRegisterUrl,
  defaultButtonText: 'Apply To Bid',
};
